import { Typography } from "@mui/material";
import MainContainer from "components/layout/MainContainer/MainContainer";
import Suspenseful from "components/Suspenseful";
import Groups from "./Groups";
import BookendsProvider from "lib/BookendsProvider";
import { PageContainer } from "components/UI/Structure/PageContainer";
import FooterBar from "components/UI/FooterBar";

export default function GroupPage() {

  return (
    <BookendsProvider>
      <MainContainer>
        <PageContainer>
          <Typography variant='h1'>Groups</Typography>
          <Suspenseful
            component={Groups}
          />
        </PageContainer>
      </MainContainer>

      <FooterBar />
    </BookendsProvider>
  )
}
